export const RULE_EDITOR_CHARS = {
    GROUP_OPEN: '{',
    GROUP_CLOSE: '}',
    FUNC_OPEN: '(',
    FUNC_CLOSE: ')'
};
